export var sst_event_list = `
{{#data}}
    {{> sst_events/_sst_event_row operation_id = ../operation_id hideActive = ../hideActive}}
{{/data}}
`;
